'use client';

import { useTranslation } from 'next-i18next';

import { useState } from 'react';

import { Box, Button, HStack, StackProps, Text, useSlotRecipe } from '@chakra-ui/react';

import { urlMap } from '@nocowanie/core/consts';
import { IconsLinear } from '@nocowanie/icons/linear';

export const ResultsOrderInfo = ({ ...props }: StackProps) => {
    const { t } = useTranslation('listing', { keyPrefix: 'orderInfo' });
    const recipe = useSlotRecipe({ key: 'resultsOrderInfo' });
    const styles = recipe({});
    const [showOrderInfoBox, setShowOrderInfoBox] = useState(true);

    if (!showOrderInfoBox) return;

    const renderInfo = (isMobile: boolean) => (
        <Box
            as={'span'}
            display={{ base: isMobile ? 'inline' : 'none', md: isMobile ? 'none' : 'inline' }}
        >
            <Text as={'span'} color={'gray.700'}>
                {t(isMobile ? 'textMobile' : 'text')}
            </Text>
            <a href={urlMap.termsOfServicePositioning} target="_blank">
                {t(isMobile ? 'linkMobile' : 'link')} <IconsLinear.Export size={'xs'} ml={0.5} />
            </a>
        </Box>
    );

    return (
        <HStack css={styles.root} {...props}>
            <Box>
                <IconsLinear.InfoCircle
                    size={'sm'}
                    fontSize={'xl'}
                    color={'gray.700'}
                    mr={2}
                    rotate={'180deg'}
                />
                {renderInfo(true)}
                {renderInfo(false)}
            </Box>
            <Button
                variant={'link'}
                onClick={() => setShowOrderInfoBox(false)}
                aria-label={t('close')}
            >
                <IconsLinear.Close size={'xs'} />
            </Button>
        </HStack>
    );
};
